var render = function render(){var _vm=this,_c=_vm._self._c;return _c('debug-only',[_c('v-btn',{attrs:{"to":"/debug/trip"}},[_vm._v(" Trip ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }